import { render, staticRenderFns } from "./upComingList.vue?vue&type=template&id=7874cd60&scoped=true"
import script from "./upComingList.vue?vue&type=script&lang=js"
export * from "./upComingList.vue?vue&type=script&lang=js"
import style0 from "./upComingList.vue?vue&type=style&index=0&id=7874cd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7874cd60",
  null
  
)

export default component.exports